
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { EnumHomeworkLevel, IMemberHomeworkItem } from '@xt/client'
import type { ClasshourMemberHomework } from '@xt/client/entities/course-v2/types.d'

@Observer
@Component({
  components: { HeaderImage, LazyImg }
})
export default class ClasshourHomeworkItem extends Vue {
  @Prop({}) data: ClasshourMemberHomework
  @Prop({}) defaultTitle: string

  get EnumHomeworkLevel() {
    return EnumHomeworkLevel
  }

  get isReview() {
    return this.data.reviewed === true
  }

  get firstUrl() {
    return this.data.homeworkPicList[0]?.waterUrl
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
